import { captureEvent } from '@sentry/react';
import type { Event } from '@sentry/types';
import { z } from 'zod';

export function reportCrmFailure(endpoint: 'internalCrm' | 'internalCrmGoogle', cause: unknown) {
  const rawCode = (cause as { code?: string })?.code;
  if (
    [
      'functions/permission-denied',
      'functions/unauthenticated',
      'functions/invalid-argument',
      'functions/not-found',
      'functions/aborted',
      'functions/cancelled',
    ].includes(rawCode || '')
  )
    return;
  const code =
    cause instanceof z.ZodError
      ? 'invalid-response'
      : ['functions/internal', 'functions/unavailable', 'functions/deadline-exceeded'].includes(
          rawCode || ''
        )
      ? rawCode!
      : 'unexpected';
  // Deliberately omit the original exception, command, response, account and record IDs.
  captureEvent({
    message: 'CRM request failed',
    level: 'error',
    tags: { crm_request: true, endpoint, code },
    fingerprint: ['crm-request', endpoint, code],
  });
}

/** beforeSend runs last, after integrations have attached Redux state and breadcrumbs. */
export function sanitizeCrmDiagnostic(event: Event): Event {
  if (event.tags?.crm_request !== true) return event;
  return {
    event_id: event.event_id,
    timestamp: event.timestamp,
    platform: event.platform,
    environment: event.environment,
    release: event.release,
    message: 'CRM request failed',
    level: 'error',
    tags: { crm_request: true, endpoint: event.tags.endpoint, code: event.tags.code },
    fingerprint: event.fingerprint,
  };
}
